import { useQuery } from '@tanstack/vue-query';
import { getApi } from './api';

export default () => useQuery({
  queryKey: ['passkey-credentials'],
  queryFn: () => {
    const { api, baseURL } = getApi();
    return api
      .get(`/api/passkeys`, { baseURL })
      .then((res) => res.data.data);
  },
});
